<form [formGroup]="blockForm" class="sb" (submit)="$event.preventDefault()">
  <p class="sb-intro">
    En el horario bloqueado no se pueden agendar citas, ni desde el calendario ni desde tu enlace de reservas.
  </p>

  <!-- Who -->
  <fieldset class="sb-field">
    <legend class="sb-label">¿Para quién?</legend>
    <div class="sb-chips" role="radiogroup">
      <button type="button" role="radio" class="sb-chip" [attr.aria-checked]="!blockForm.value.professionalId"
        (click)="setProfessional(null)">
        Todo el negocio
      </button>
      @for (p of professionals(); track p.userId) {
      <button type="button" role="radio" class="sb-chip" [attr.aria-checked]="blockForm.value.professionalId === p.userId"
        (click)="setProfessional(p.userId)">
        <span class="sb-dot" [style.background]="p.color || '#465FFF'" aria-hidden="true"></span>
        {{ professionalName(p) }}
      </button>
      }
      @if (isLoadingProfessionals()) {
      <span class="sb-chip sb-chip--loading" aria-hidden="true"></span>
      }
    </div>
  </fieldset>

  <!-- When: dates -->
  <div class="sb-field">
    <div class="sb-row">
      <div class="sb-col">
        <label class="sb-label" for="sb-start-date">{{ multiDay() ? 'Desde el' : 'Día' }}</label>
        <input #startDateInput id="sb-start-date" type="text" class="sb-input" readonly
          [class.sb-input--error]="showError('startDate')" />
      </div>
      @if (multiDay()) {
      <div class="sb-col">
        <label class="sb-label" for="sb-end-date">Hasta el</label>
        <input #endDateInput id="sb-end-date" type="text" class="sb-input" readonly
          [class.sb-input--error]="blockForm.hasError('endDateBeforeStartDate')" />
      </div>
      }
    </div>
    <label class="sb-switch">
      <input type="checkbox" [checked]="multiDay()" (change)="toggleMultiDay()" />
      <span class="sb-switch__track" aria-hidden="true"></span>
      Bloquear varios días seguidos
    </label>
    @if (multiDay()) {
    <p class="sb-hint">El mismo horario se bloquea en cada uno de esos días.</p>
    }
  </div>

  <!-- When: hours -->
  <fieldset class="sb-field">
    <legend class="sb-label">Horario</legend>
    <div class="sb-chips">
      @for (preset of timePresets; track preset.label) {
      <button type="button" class="sb-chip" [attr.aria-pressed]="isPresetActive(preset)" (click)="applyPreset(preset)">
        {{ preset.label }}
      </button>
      }
    </div>
    <div class="sb-row sb-row--times">
      <div class="sb-col">
        <label class="sb-label sb-label--sub" for="sb-start-time">Desde</label>
        <input id="sb-start-time" type="time" formControlName="startTime" step="900" class="sb-input"
          [class.sb-input--error]="showError('startTime')" />
      </div>
      <div class="sb-col">
        <label class="sb-label sb-label--sub" for="sb-end-time">Hasta</label>
        <input id="sb-end-time" type="time" formControlName="endTime" step="900" class="sb-input"
          [class.sb-input--error]="showError('endTime') || (blockForm.hasError('endTimeBeforeStartTime') && blockForm.get('endTime')?.touched)" />
      </div>
    </div>
    @if (showError('startTime') || showError('endTime')) {
    <p class="sb-error">Elige la hora de inicio y la hora final.</p>
    } @else if (blockForm.hasError('endTimeBeforeStartTime') && blockForm.get('endTime')?.touched) {
    <p class="sb-error">La hora final debe ser después de la hora de inicio.</p>
    }
  </fieldset>

  <!-- Why -->
  <div class="sb-field">
    <label class="sb-label" for="sb-title">Motivo <span class="sb-optional">(opcional)</span></label>
    <div class="sb-chips sb-chips--tight">
      @for (reason of reasons; track reason) {
      <button type="button" class="sb-chip sb-chip--sm" [attr.aria-pressed]="blockForm.value.title === reason"
        (click)="setReason(reason)">
        {{ reason }}
      </button>
      }
    </div>
    <input id="sb-title" type="text" formControlName="title" class="sb-input" maxlength="200"
      placeholder="Escribe otro motivo" />
    <p class="sb-hint">Se muestra en el calendario sobre el horario bloqueado.</p>
  </div>

  <div class="sb-field">
    <label class="sb-label" for="sb-notes">Nota interna <span class="sb-optional">(opcional)</span></label>
    <textarea id="sb-notes" rows="2" formControlName="description" class="sb-input sb-textarea" maxlength="500"></textarea>
  </div>

  @if (summary(); as text) {
  <p class="sb-summary" aria-live="polite">{{ text }}</p>
  }
</form>
